import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import axios from "axios";
import { Container } from "react-bootstrap";

import emptyListErrorImg from "../../../image/profile/empty-list.png";
import { commentApi } from "../../../utility/api/apiList";

import {
  showInfoAlert,
  showModalAlert,
} from "../../../redux/actions/alert/alertActions";

import useAxios from "../../../hooks/useAxios";
import useFilter from "../../../hooks/useFilter";
import scrollToTop from "../../../libs/scrollToTop";
import { calculatePageSize } from "../../../libs/pagingDetail";

import DeleteUserComment from "../../../components/private/user/userCommentComponent/deleteUserComment";
import PaginationComponent from "../../../components/public/pagination";
import UserCommentComponent from "../../../components/private/user/userCommentComponent";

import LoadingComponent from "../../../components/public/loading";
import EmptyListErrorComponent from "../../../components/public/error/emptyListErrorComponent";

export default function UserCommentContainer() {
  const dispatch = useDispatch();
  const { onChange, filterState } = useFilter();

  const commentsPageSize = filterState["page_size"] || 5;
  const {
    data: comments,
    error: commentsError,
    isLoaded: commentsIsLoaded,
    run: commentRun,
  } = useAxios({
    url: commentApi,
    params: {
      my_comment: "True",
      order_by: "-id",
      page_size: commentsPageSize,
      page: filterState["page"] || 1,
    },
  });

  useEffect(() => {
    document.title = "نظر‌های من";
    scrollToTop();
    onChange("page", 1);
  }, []);

  useEffect(() => {
    commentRun();
  }, [filterState["page"]]);

  const handleDeleteComment = (commentID) => {
    axios
      .delete(`${commentApi}${commentID}/`)
      .then(() => {
        dispatch(showInfoAlert("نظر شما درباره این آزمایش حذف شد"));
        commentRun();
      })
      .catch(() => {
        dispatch(showInfoAlert("متاسفانه مشکلی پیش آمده، لطفا بعدا امتحان کنید."));
      });
  };

  const handleDelete = (id) => {
    dispatch(
      showModalAlert({
        content: (
          <DeleteUserComment
            handleDeleteComment={handleDeleteComment}
            commentID={id}
          />
        ),
        maxWidth: "290px",
      })
    );
  };

  let element = null;
  if (!commentsIsLoaded && !commentsError) {
    element = <LoadingComponent />;
  } else if (comments?.results.length === 0) {
    element = (
      <EmptyListErrorComponent
        errorMessage="تا کنون هیچ نظری ثبت نشده است."
        errorMessageImg={emptyListErrorImg}
      />
    );
  } else {
    element = comments?.results?.map((comment) => (
      <UserCommentComponent
        key={comment.id}
        comment={comment}
        runGetComments={commentRun}
        handleDelete={handleDelete}
      />
    ));
  }

  return (
    <Container className="mt-4">
      {element}
      <PaginationComponent
        pageNumber={calculatePageSize(comments?.count, commentsPageSize)}
        currentPage={filterState["page"] || 1}
        handleChangePage={(e, value) => {
          onChange("page", value);
        }}
        className="mt-5"
        defaulPage={1}
      />
    </Container>
  );
}
